import { InstitutionInfo } from './institution-info.model';

export class CityInfo {
  name: string;
  institutionInfoes: InstitutionInfo[];
  orderNumber: number;

  constructor(name: string, institutionInfoes: InstitutionInfo[], orderNumber: number) {
    this.name = name;
    this.institutionInfoes = institutionInfoes;
    this.orderNumber = orderNumber;
  }
}
